import user from './rules/user'
import guest from './rules/guest'
import pricingAdmin from './rules/role'

export default {
	guest,
	user,
	pricingAdmin,
}
